export const digitalAssets = [
  {
    id: "asset-assessment-report",
    title: { vi: "Báo cáo thẩm định tổng thể", en: "Business assessment report" },
    description: { vi: "Báo cáo hiện trạng và các ưu tiên cải tổ doanh nghiệp.", en: "Current-state findings and priority actions for business improvement." },
    type: "REPORT",
    group: "ASSESSMENT",
    status: "COMPLETED",
    grantedAt: "12/06/2024",
    expiresAt: "12/12/2024",
    allowDownload: true,
    icon: "fas fa-file-chart-column",
    action: { vi: "Xem báo cáo", en: "View report" },
  },
  {
    id: "asset-solar-course",
    title: { vi: "Khóa học nền tảng Điện Mặt trời", en: "Solar energy fundamentals" },
    description: { vi: "Nền tảng kỹ thuật Solar dành cho người mới bắt đầu.", en: "Technical Solar foundations for new learners." },
    type: "COURSE",
    group: "TALENT",
    status: "IN_PROGRESS",
    progress: 68,
    grantedAt: "03/07/2024",
    expiresAt: "03/07/2025",
    allowDownload: false,
    icon: "fas fa-sun",
    action: { vi: "Tiếp tục học", en: "Continue learning" },
  },
  {
    id: "asset-consulting-checklist",
    title: { vi: "Bộ checklist vận hành doanh nghiệp", en: "Business operations checklist" },
    description: { vi: "Bộ biểu mẫu giúp chuẩn hóa các hoạt động vận hành cốt lõi.", en: "Templates for standardizing core operating activities." },
    type: "FORM",
    group: "ASSESSMENT",
    status: "NOT_STARTED",
    grantedAt: "18/07/2024",
    allowDownload: true,
    icon: "fas fa-list-check",
    action: { vi: "Sử dụng biểu mẫu", en: "Use template" },
  },
  {
    id: "asset-sales-video",
    title: { vi: "Video tư vấn giải pháp Solar", en: "Solar solution selling" },
    description: { vi: "Chuỗi video thực hành tư vấn và trình bày giải pháp Solar.", en: "Practical videos for consulting and presenting Solar solutions." },
    type: "VIDEO",
    group: "TALENT",
    status: "IN_PROGRESS",
    progress: 34,
    grantedAt: "24/07/2024",
    allowDownload: false,
    icon: "fas fa-play",
    action: { vi: "Xem video", en: "Watch video" },
  },
  {
    id: "asset-platform-guide",
    title: { vi: "Hướng dẫn sử dụng nền tảng quản trị", en: "Management platform guide" },
    description: { vi: "Tài liệu hướng dẫn cấu hình và sử dụng hệ thống.", en: "Configuration and usage guide for the management platform." },
    type: "DOCUMENT",
    group: "TECHNOLOGY",
    status: "EXPIRING",
    grantedAt: "01/08/2024",
    expiresAt: "30/08/2024",
    allowDownload: true,
    icon: "fas fa-book-open",
    action: { vi: "Đọc tài liệu", en: "Read document" },
  },
  {
    id: "asset-system-tool",
    title: { vi: "Công cụ theo dõi tiến độ triển khai", en: "Deployment progress tool" },
    description: { vi: "Công cụ số giúp theo dõi đầu việc và kết quả bàn giao.", en: "Digital tool for tracking tasks and deliverables." },
    type: "DIGITAL_TOOL",
    group: "TECHNOLOGY",
    status: "EXPIRED",
    grantedAt: "15/05/2024",
    expiresAt: "15/07/2024",
    allowDownload: false,
    icon: "fas fa-grid-2-plus",
    action: { vi: "Liên hệ gia hạn", en: "Contact to renew" },
  },
];

export const deploymentPrograms = [
  {
    id: "program-assessment",
    code: "EPC-2407-01",
    title: { vi: "Gói thẩm định tổng thể doanh nghiệp", en: "Full business assessment" },
    description: { vi: "Đánh giá hiện trạng vận hành, tài chính và năng lực đội ngũ.", en: "Review of operations, finance and team capabilities." },
    group: "ASSESSMENT",
    status: "IN_PROGRESS",
    progress: 68,
    startDate: "08/07/2024",
    expectedEndDate: "30/08/2024",
    currentStage: { vi: "Phân tích dữ liệu", en: "Data analysis" },
    nextAction: { vi: "Bổ sung báo cáo dòng tiền tháng 07", en: "Provide July cash-flow report" },
    manager: "Lê Minh Khôi",
    managerRole: "EPC Advisor",
  },
  {
    id: "program-talent",
    code: "TAL-2406-08",
    title: { vi: "Chương trình Talent: Kỹ thuật Solar", en: "Talent program: Solar engineering" },
    description: { vi: "Lộ trình đào tạo kỹ thuật từ nền tảng đến thực chiến.", en: "Technical learning path from foundations to practice." },
    group: "TALENT",
    status: "WAITING_CUSTOMER",
    progress: 42,
    startDate: "15/07/2024",
    expectedEndDate: "15/10/2024",
    currentStage: { vi: "Thực hành hệ thống", en: "System practice" },
    nextAction: { vi: "Hoàn thành bài kiểm tra mô-đun 02", en: "Complete module 02 assessment" },
    manager: "Nguyễn Minh",
    managerRole: "Talent Coach",
  },
  {
    id: "program-technology",
    code: "TECH-2408-03",
    title: { vi: "Triển khai nền tảng quản trị", en: "Management platform deployment" },
    description: { vi: "Cấu hình hệ thống và bàn giao quy trình vận hành cho đội ngũ.", en: "System setup and operations handover for the team." },
    group: "TECHNOLOGY",
    status: "WAITING_CONSULTANT",
    progress: 25,
    startDate: "01/08/2024",
    expectedEndDate: "30/09/2024",
    currentStage: { vi: "Thiết kế giải pháp", en: "Solution design" },
    nextAction: { vi: "Chờ HITECH gửi bản cấu hình thử nghiệm", en: "Waiting for HITECH test configuration" },
    manager: "Phạm Hoàng Anh",
    managerRole: "Solution Lead",
  },
];

export const assetTypeLabels = {
  COURSE: { vi: "Khóa học", en: "Course" }, VIDEO: { vi: "Video", en: "Video" }, DOCUMENT: { vi: "Tài liệu", en: "Document" },
  CURRICULUM: { vi: "Giáo trình", en: "Curriculum" }, FORM: { vi: "Biểu mẫu", en: "Form" }, REPORT: { vi: "Báo cáo", en: "Report" }, DIGITAL_TOOL: { vi: "Công cụ số", en: "Digital tool" },
};

export const groupLabels = {
  ASSESSMENT: { vi: "Gói thẩm định", en: "Assessment" }, TALENT: { vi: "Chương trình học Talent", en: "Talent program" }, TECHNOLOGY: { vi: "Hệ sinh thái Công nghệ", en: "Technology ecosystem" },
};
